import {
  Navbar,
  Hero,
  FeatureStrip,
  HowItWorks,
  ExtensionSection,
  Protection,
  FAQ,
  FinalCTA,
  Footer,
} from "@/components/landing";

/** Public marketing page ("Deep water" direction). */
export function LandingPage() {
  return (
    <div className="relative min-h-screen bg-background">
      <Navbar />
      <main>
        <Hero />
        <FeatureStrip />
        <HowItWorks />
        <ExtensionSection />
        <Protection />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default LandingPage;
